import React, { useEffect, useRef, useState } from 'react'

import { Icon } from '../../components/Icon'
import Notes from './Notes'
import Policies from './Policies'
import Employment from './Employment'
import SafeGuarding from './SafeGuarding'

import Modal from '../../components/UI/UIModal'
import TrainingRecords from './TrainingRecords'
import UIButton from '../../components/UI/UIButton'
import UITabBar from '../../components/UI/UITabBar'
import ProfileInformation from './ProfileInformation'
import UITextArea from '../../components/UI/UITextArea'
import { useQuery, useQueryClient } from 'react-query'
import { getSCRroles, getScrSingleRecord } from './apiCalls'
import {
  archiveUser,
  changeUserRoleApi,
  createNote,
  deleteUser,
  suspendUser,
} from '../../api/admin/scr'
import { createUser, ErrorResponse } from '../../utils/types'
import { toast } from 'react-toastify'
import ButtonMenue from '../../components/UI/ButtonMenue'
import UiSelect from '../../components/UI/UISelect'
import { capitalizeFirstLetter } from '../../utils/utils'
import { statusBgColor } from './utils'
import UITextInput from '../../components/UI/UITextInput'
interface roles {
  label: string
  value: string
}
interface UserViewProps {
  setIsView: React.Dispatch<React.SetStateAction<string>>
  recordId: string
  schoolData: string
  rolesData: roles[]
}

const UserView = ({ recordId, schoolData, setIsView }: UserViewProps) => {
  const queryClient = useQueryClient()
  const wrapperRefNotificationMenu = useRef<HTMLDivElement>(null)
  const [detail, setDetail] = useState('')
  const [notesTitle, setNotesTitle] = useState<string>('')
  const [isEdit, setIsEdit] = useState<boolean>(false)
  const [activeTab, setActiveTab] = useState<string>('Profile Information')
  const [isOpenMenu, setIsOpenMenu] = useState<boolean>(false)
  const [isOpenAddNotesModal, setIsOpenAddNotesModal] = useState<boolean>(false)
  const [isEditUserModalOpen, setIsEditUserModalOpen] = useState<boolean>(false)
  const [isOpenContactModal, setIsOpenContactModal] = useState<boolean>(false)
  const [role, setRole] = useState<string>('')
  const [isOpenEditNotesModal, setIsOpenEditNotesModal] =
    useState<boolean>(false)
  const [isOpenDeleteNotesModal, setIsOpenDeleteNotesModal] =
    useState<boolean>(false)
  const [isSuspendUserModal, setIsSuspendUserModal] = useState<boolean>(false)
  const [isUnSuspendUserModal, setIsUnSuspendUserModal] =
    useState<boolean>(false)

  const [isArchiveUserModal, setIsArchiveUserModal] = useState<boolean>(false)
  const [isOpenDeleteUserModal, setIsOpenDeleteUserModal] =
    useState<boolean>(false)
  const [addNotesLoading, setAddNotesLoading] = useState<boolean>(false)

  const handlePressTab = (tab: string) => {
    setActiveTab(tab)
  }

  const scrRecord = useQuery(
    'scrRecord',
    () => getScrSingleRecord(schoolData, recordId),
    {
      refetchOnWindowFocus: false, // Disable refetch on window focus
      refetchOnReconnect: false, // Disable refetch on network reconnect
    }
  )

  const roles = useQuery(
    'role',
    () => getSCRroles(),

    {
      refetchOnWindowFocus: false, // Disable refetch on window focus
      refetchOnReconnect: false, // Disable refetch on network reconnect
    }
  )

  const rolesData = roles?.data?.map((item) => ({
    value: item.id,
    label: item.role,
  }))

  const removeUser = async (): Promise<void> => {
    try {
      const response = (await deleteUser({ id: recordId })) as {
        status?: string
        data: createUser
      }
      if (response?.status == 'successful') {
        queryClient.fetchQuery('scr')
        scrRecord.refetch()
        setIsView('centeral-records')
        setIsOpenDeleteUserModal(false)
        toast.success('User Removed', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }
  const SuspendUser = async (): Promise<void> => {
    try {
      const response = (await suspendUser(
        schoolData,
        'suspended',
        recordId
      )) as {
        status?: string
        data: createUser
      }
      if (response?.status == 'successful') {
        queryClient.fetchQuery('scr')
        scrRecord.refetch()
        setIsView('user-view')
        setIsOpenDeleteUserModal(false)
        setIsSuspendUserModal(false)
        toast.success('User Suspended', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }
  const UnSuspendUser = async (): Promise<void> => {
    try {
      const response = (await suspendUser(schoolData, 'active', recordId)) as {
        status?: string
        data: createUser
      }
      if (response?.status == 'successful') {
        queryClient.fetchQuery('scr')
        scrRecord.refetch()
        setIsView('user-view')
        setIsOpenDeleteUserModal(false)
        setIsUnSuspendUserModal(false)
        toast.success('User Unsuspended', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }

  const ArchivedUser = async (): Promise<void> => {
    try {
      const response = (await archiveUser(schoolData, recordId)) as {
        status?: string
        data: createUser
      }
      if (response?.status == 'successful') {
        queryClient.fetchQuery('scr')
        scrRecord.refetch()
        setIsView('user-view')
        setIsOpenDeleteUserModal(false)
        setIsSuspendUserModal(false)
        setIsArchiveUserModal(false)
        toast.success('User Archived', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }
  const changeUserRole = async (): Promise<void> => {
    try {
      const response = (await changeUserRoleApi(role, recordId)) as {
        status?: string
        data: createUser
      }
      if (response?.status == 'successful') {
        queryClient.fetchQuery('scr')
        scrRecord.refetch()

        setIsView('user-view')
        setIsEditUserModalOpen(false)
        toast.success('User Role Updated', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }

  const addNote = async (): Promise<void> => {
    setAddNotesLoading(true)
    try {
      const response = (await createNote(
        notesTitle,
        schoolData,
        detail,
        recordId
      )) as {
        status?: string
        data: createUser
      }
      if (response?.status == 'successful') {
        queryClient.fetchQuery('scr')
        queryClient.fetchQuery('Noters')
        scrRecord.refetch()
        setIsView('user-view')
        setIsOpenAddNotesModal(false)
        toast.success('Note added', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('An error occurred while adding note.', {
        position: 'top-right',
      })
    } finally {
      setAddNotesLoading(true)
    }
  }

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      // Check if the click is outside the component

      if (
        wrapperRefNotificationMenu.current &&
        !wrapperRefNotificationMenu.current.contains(event.target as Node)
      ) {
        setIsOpenMenu(false) // Close the dropdown if it's open
      }
    }
    // Add event listener for clicks outside the component
    document.addEventListener('mousedown', handleOutsideClick)
    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [])

  const storedPermissions = localStorage.getItem('userPermissions')
  const checkPolicy = JSON.parse(storedPermissions ? storedPermissions : '')

  const baseTitles = [
    'Profile Information',
    'Employment',
    'Safeguarding',
    'Training Records',
    'Notes',
  ]

  const policyTitles = [...baseTitles, 'Policies']

  const titles = checkPolicy.includes('Policy') ? policyTitles : baseTitles

  return (
    <div
      className={
        'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl p-5 '
      }
    >
      <div
        style={{
          height: 'calc(100vh - 100px)',
          overflow: 'auto',
          // scrollbarWidth: 'none',
        }}
      >
        <div className={'flex w-full justify-between items-start'}>
          <div className="flex gap-5 items-center flex-1">
            {!scrRecord?.data?.profileImageUrl ? (
              <div className="flex items-center justify-center rounded-full bg-bluishGreen text-white w-[100px] h-[100px] border-4 border-[#FFFFFF33]">
                <p className="text-lg text-white leading-8 font-bold">
                  {scrRecord?.data?.firstName?.charAt(0)?.toUpperCase()}{' '}
                  {scrRecord?.data?.lastName?.charAt(0)?.toUpperCase()}
                </p>
              </div>
            ) : (
              <div className="flex items-center justify-center rounded-full bg-bluishGreen text-white w-[100px] h-[100px] border-4 border-[#FFFFFF33]">
                <img
                  src={scrRecord?.data?.profileImageUrl}
                  width={64}
                  height={64}
                  alt=""
                  className="rounded-full bg-transparent border-none w-16 h-16"
                />
              </div>
            )}

            <div>
              <p className="text-lg leading-8 font-bold text-text2">
                {`${scrRecord?.data?.firstName == null ? '' : scrRecord?.data?.firstName} ${scrRecord?.data?.lastName == null ? '' : scrRecord?.data?.lastName}`}
                <span className="text-xs font-medium leading-5 text-text3">
                  {/* @{scrRecord?.data?.userName} */}
                </span>
              </p>
              <p className="text-xs font-medium leading-5 text-bluishGreen">
                {scrRecord?.data?.email}
              </p>
              <div className="flex gap-2 max-w-[200px] mt-2">
                <div className="rounded-[40px] w-fit bg-gray3 p-2 px-3">
                  <p className="text-xs font-medium leading-5 text-bluishGreen">
                    {scrRecord?.data?.role}
                  </p>
                </div>
                <div
                  className={`rounded-[40px] justify-center text-center items-center bg-${statusBgColor(scrRecord?.data?.status || '')} py-2 px-3 flex-1`}
                >
                  <p className="text-xs font-medium leading-5 text-bluishGreen">
                    {capitalizeFirstLetter(scrRecord?.data?.status || '')}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex gap-3">
            <div
              onClick={() => {
                setIsView('centeral-records')
              }}
              className="gap-3 bg-gray1 items-center justify-between text-white px-5 py-3 flex rounded-3xl cursor-pointer"
            >
              <Icon
                name={'IconArrowLeft'}
                strokeWidth={1.2}
                stroke={'white'}
                width={16}
                height={16}
              />
              <p className={'font-semibold text-sm leading-6 text-text1'}>
                Back
              </p>
            </div>

            <ButtonMenue
              wrapperRefNotificationMenu={wrapperRefNotificationMenu}
              isOpen={isOpenMenu}
              items={[
                {
                  label: isEdit ? 'Cancel ' : 'Edit',
                  onClick: () => {
                    setIsEdit(!isEdit)
                  },
                  icon: 'IconEdit',
                  iconColor: isEdit ? '#FF6666' : '#02698C',
                  // textColor: isEdit ? 'text-textError' : '#02698C',
                },
                {
                  label: 'Suspend',
                  onClick: () => {
                    setIsSuspendUserModal(true)
                  },
                  icon: 'IconPauseCircle',
                  iconColor: '#02698C',
                  display:
                    scrRecord?.data?.status == 'suspended' ? false : true,
                },
                {
                  label: 'Un-Suspend',
                  onClick: () => {
                    setIsUnSuspendUserModal(true)
                  },
                  icon: 'IconPauseCircle',
                  iconColor: '#02698C',
                  display:
                    scrRecord?.data?.status == 'suspended' ? true : false,
                },
                {
                  label: 'Archive',
                  onClick: () => setIsArchiveUserModal(true),
                  icon: 'IconArchive',
                  iconColor: '#02698C',
                },
                {
                  label: 'Contact',
                  onClick: () => setIsOpenContactModal(true),
                  icon: 'IconMail',
                  iconColor: '#02698C',
                },
                {
                  label: 'Add Note',
                  onClick: () => setIsOpenAddNotesModal(!isOpenAddNotesModal),
                  icon: 'IconStickerSquare',
                  iconColor: '#02698C',
                },
                {
                  label: 'Role',
                  onClick: () => {
                    setRole(scrRecord?.data?.role || '')
                    setIsEditUserModalOpen(!isOpenAddNotesModal)
                  },
                  icon: 'IconStickerSquare',
                  iconColor: '#02698C',
                },
                {
                  label: 'Remove User',
                  onClick: () => setIsOpenDeleteUserModal(true),
                  icon: 'IconTrash',
                  iconColor: '#FF6666',
                  textColor: 'text-textError',
                },
              ]}
            >
              <div
                onClick={() => setIsOpenMenu(!isOpenMenu)}
                className={`gap-3 border border-gray2 items-center justify-between text-white px-4 py-3 flex rounded-3xl cursor-pointer ${isOpenMenu ? 'bg-[#CCE1E8]' : 'bg-transparent'}`}
              >
                <Icon
                  name={'IconDotsVertical'}
                  strokeWidth={1.2}
                  stroke={'#02698C'}
                  width={16}
                  height={16}
                />
              </div>
            </ButtonMenue>
          </div>
          {/* Delete User Modal */}
          <Modal
            customStyle={{ borderRadius: 16, padding: 20, width: 480 }}
            isOpen={isOpenDeleteUserModal}
            onClose={() => setIsOpenDeleteUserModal(false)}
          >
            <div
              className={'max-h-[80vh] items-center p-4 flex flex-col gap-4'}
            >
              <div
                onClick={() => setIsOpenDeleteUserModal(false)}
                className="flex w-[100%] justify-end cursor-pointer"
              >
                <Icon
                  name={'IconCross'}
                  stroke="#02698C"
                  height={16}
                  width={16}
                />
              </div>
              <div className="flex items-center w-[100%] justify-center">
                <Icon
                  name="IconAlertTriangle"
                  stroke={'#FF6666'}
                  strokeWidth={0.6}
                  height={52}
                  width={52}
                />
              </div>
              <div className="flex flex-col gap-2 items-center w-[100%] justify-center mb-4">
                <h1 className={'text-text2 text-lg font-bold leading-6'}>
                  Remove User
                </h1>
                <p className={'text-sm text-text1 font-normal leading-6'}>
                  Are you sure you want to remove this user?
                </p>
              </div>
              <div className="w-full flex flex-col gap-4">
                <button
                  onClick={() => {
                    removeUser()
                  }}
                  className="text-textError border-textError border-[1px] min-h-[48px] font-medium rounded-[72px] text-[14px]"
                >
                  Yes, I’m sure
                </button>
                <button
                  onClick={() => setIsOpenDeleteUserModal(false)}
                  className="text-text1 border-textError bg-gray2 min-h-[48px] font-medium rounded-[72px] text-[14px]"
                >
                  Cancel
                </button>
              </div>
            </div>
          </Modal>
          {/* Add & Edit Notes Modal */}
          <Modal
            customStyle={{
              borderRadius: 16,
              padding: '20px 16px',
              width: '480px',
            }}
            isOpen={
              isOpenEditNotesModal ? isOpenEditNotesModal : isOpenAddNotesModal
            }
            onClose={() => {
              setIsOpenEditNotesModal(false)
              setIsOpenAddNotesModal(false)
            }}
          >
            <div
              className={
                'max-h-[80vh] min-h-[45vh] items-center  p-4 flex flex-col gap-4'
              }
            >
              <div
                onClick={() => {
                  setIsOpenEditNotesModal(false)
                  setIsOpenAddNotesModal(false)
                }}
                className="flex w-[100%] justify-end cursor-pointer"
              >
                <Icon
                  name={'IconCross'}
                  stroke="#02698C"
                  height={16}
                  width={16}
                />
              </div>
              <div className="flex items-center w-[100%] justify-center">
                <Icon
                  name={'IconStickerSquare'}
                  stroke={'#02698C'}
                  strokeWidth={0.5}
                  height={56}
                  width={56}
                />
              </div>
              <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
                <h1 className={'text-text2 text-lg font-bold leading-6'}>
                  {isOpenEditNotesModal ? 'Edit Note' : 'Add Note'}
                </h1>
                <p className={'text-sm leading-5 text-text1 font-normal'}>
                  {isOpenEditNotesModal
                    ? ' Please update the details about this note'
                    : ' Please enter the details about this note'}
                </p>
              </div>
              <div className="w-full flex-col flex gap-4 mt-3">
                <div>
                  <UITextInput
                    iconName=""
                    label="Title*"
                    placeholder="title"
                    onChange={(e) => {
                      setNotesTitle(e.target.value)
                    }}
                    value={notesTitle}
                  />
                </div>
                <div>
                  <UITextArea
                    label="Note Details*"
                    placeholder="Write Note Details here"
                    rows={7}
                    onChange={(e) => {
                      setDetail(e.target.value)
                    }}
                  />
                </div>
              </div>
              <div className="w-full mt-4">
                <UIButton
                  disabled={detail == ''}
                  loading={addNotesLoading}
                  onClick={
                    isOpenEditNotesModal ? () => console.log('') : addNote
                  }
                  label={isOpenEditNotesModal ? 'Update' : 'Add'}
                />
              </div>
            </div>
          </Modal>
          {/* Delete Notes Modal & suspend user modal */}
          <Modal
            customStyle={{ borderRadius: 16, padding: 20, width: 480 }}
            isOpen={
              isSuspendUserModal
                ? isSuspendUserModal
                : isArchiveUserModal
                  ? isArchiveUserModal
                  : isOpenDeleteNotesModal
            }
            onClose={() => {
              setIsOpenDeleteNotesModal(false)
              setIsSuspendUserModal(false)
              setIsArchiveUserModal(false)
            }}
          >
            <div
              className={'max-h-[80vh] items-center p-4 flex flex-col gap-4'}
            >
              <div
                onClick={() => {
                  setIsOpenDeleteNotesModal(false)
                  setIsSuspendUserModal(false)
                  setIsArchiveUserModal(false)
                }}
                className="flex w-[100%] justify-end cursor-pointer"
              >
                <Icon
                  name={'IconCross'}
                  stroke="#02698C"
                  height={16}
                  width={16}
                />
              </div>
              <div className="flex items-center w-[100%] justify-center">
                <Icon
                  name={
                    isSuspendUserModal
                      ? 'IconPauseCircle'
                      : isArchiveUserModal
                        ? 'IconArchive'
                        : 'IconAlertTriangle'
                  }
                  stroke={'#FF6666'}
                  strokeWidth={0.6}
                  height={52}
                  width={52}
                />
              </div>
              <div className="flex flex-col gap-2 items-center w-[100%] justify-center mb-4">
                <h1 className={'text-text2 text-lg font-bold leading-6'}>
                  {isSuspendUserModal
                    ? 'Suspend User'
                    : isArchiveUserModal
                      ? 'Archive User'
                      : 'Delete Note'}
                </h1>
                <p className={'text-sm text-text1 font-normal leading-6'}>
                  {isSuspendUserModal
                    ? 'Are you sure you want to suspend this user? '
                    : isArchiveUserModal
                      ? 'Are you sure you want to archive this user?'
                      : 'Are you sure you want to delete this note?'}
                </p>
              </div>
              <div className="w-full flex flex-col gap-4">
                {isSuspendUserModal && (
                  <button
                    onClick={SuspendUser}
                    className="text-textError border-textError border-[1px] min-h-[48px] font-medium rounded-[72px] text-[14px]"
                  >
                    Yes, I’m sure
                  </button>
                )}
                {isSuspendUserModal == false && (
                  <button
                    onClick={ArchivedUser}
                    className="text-textError border-textError border-[1px] min-h-[48px] font-medium rounded-[72px] text-[14px]"
                  >
                    Yes, I’m sure
                  </button>
                )}

                <button
                  onClick={() => {
                    setIsOpenDeleteNotesModal(false)
                    setIsSuspendUserModal(false)
                    setIsArchiveUserModal(false)
                  }}
                  className="text-text1 border-textError bg-gray2 min-h-[48px] font-medium rounded-[72px] text-[14px]"
                >
                  Cancel
                </button>
              </div>
            </div>
          </Modal>

          <Modal
            customStyle={{ borderRadius: 16, padding: 20, width: 480 }}
            isOpen={isUnSuspendUserModal}
            onClose={() => {
              setIsUnSuspendUserModal(false)
            }}
          >
            <div
              className={'max-h-[80vh] items-center p-4 flex flex-col gap-4'}
            >
              <div
                onClick={() => {
                  setIsUnSuspendUserModal(false)
                }}
                className="flex w-[100%] justify-end cursor-pointer"
              >
                <Icon
                  name={'IconCross'}
                  stroke="#02698C"
                  height={16}
                  width={16}
                />
              </div>
              <div className="flex items-center w-[100%] justify-center">
                <Icon
                  name={'IconPauseCircle'}
                  stroke={'#FF6666'}
                  strokeWidth={0.6}
                  height={52}
                  width={52}
                />
              </div>
              <div className="flex flex-col gap-2 items-center w-[100%] justify-center mb-4">
                <h1 className={'text-text2 text-lg font-bold leading-6'}>
                  Unsuspend User
                </h1>
                <p className={'text-sm text-text1 font-normal leading-6'}>
                  Are you sure you want to unsuspend this user?
                </p>
              </div>
              <div className="w-full flex flex-col gap-4">
                <button
                  onClick={UnSuspendUser}
                  className="text-textError border-textError border-[1px] min-h-[48px] font-medium rounded-[72px] text-[14px]"
                >
                  Yes, I’m sure
                </button>

                <button
                  onClick={() => {
                    setIsUnSuspendUserModal(false)
                  }}
                  className="text-text1 border-textError bg-gray2 min-h-[48px] font-medium rounded-[72px] text-[14px]"
                >
                  Cancel
                </button>
              </div>
            </div>
          </Modal>
          <Modal
            customStyle={{ borderRadius: 16, width: '480px' }}
            isOpen={isEditUserModalOpen}
            onClose={() => setIsEditUserModalOpen(false)}
          >
            <div
              className={
                'max-h-[80vh] overflow-scroll custom-scrollbar items-center px-4 py-2  flex flex-col gap-4'
              }
            >
              <div
                onClick={() => setIsEditUserModalOpen(false)}
                className="flex w-[100%] justify-end cursor-pointer"
              >
                <Icon
                  name={'IconCross'}
                  stroke="#02698C"
                  height={16}
                  width={16}
                />
              </div>
              <div className="flex items-center w-[100%] justify-center">
                <Icon
                  name={'IconUserPlus'}
                  stroke="#02698C"
                  height={52}
                  width={52}
                />
              </div>
              <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
                <p className={'text-text2 text-lg font-bold leading-6'}>
                  Edit Role
                </p>
                <p className={'text-sm text-text1 font-normal leading-6'}>
                  Please update the Role of the user you would like
                </p>
              </div>
              <div className="w-full">
                <UiSelect
                  title={'Role*'}
                  placeholder={role}
                  options={rolesData ? rolesData : []}
                  onChange={(e) => {
                    setRole(e)
                  }}
                />
              </div>
              <div className="w-full mt-4">
                <UIButton
                  label={'Update'}
                  onClick={() => {
                    changeUserRole()
                  }}
                />
              </div>
            </div>
          </Modal>
          {/* Add Contact Modal */}
          <Modal
            customStyle={{
              borderRadius: 16,
              padding: '20px 16px',
              width: '480px',
            }}
            isOpen={isOpenContactModal}
            onClose={() => {
              setIsOpenContactModal(false)
            }}
          >
            <div
              className={
                'max-h-[80vh] min-h-[45vh] items-center  p-4 flex flex-col gap-4'
              }
            >
              <div
                onClick={() => {
                  setIsOpenContactModal(false)
                }}
                className="flex w-[100%] justify-end cursor-pointer"
              >
                <Icon
                  name={'IconCross'}
                  stroke="#02698C"
                  height={16}
                  width={16}
                />
              </div>
              <div className="flex items-center w-[100%] justify-center">
                <Icon
                  name={'IconStickerSquare'}
                  stroke={'#02698C'}
                  strokeWidth={0.5}
                  height={56}
                  width={56}
                />
              </div>
              <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
                <h1 className={'text-text2 text-lg font-bold leading-6'}>
                  {'Contact User'}
                </h1>
                <p className={'text-sm leading-5 text-text1 font-normal'}>
                  {' Please select emailing platform'}
                </p>
              </div>
              <div className="w-full flex-col flex gap-4 mt-3"></div>
              <div className="w-full mt-4">
                <UIButton
                  // loading={addNotesLoading}
                  onClick={() => {
                    window.open('https://gmail.com', '_blank')
                  }}
                  label={'Gmail'}
                />
              </div>
              <div className="w-full mt-4">
                <UIButton
                  // loading={addNotesLoading}
                  onClick={() => {
                    window.open('https://outlook.com', '_blank')
                  }}
                  label={'Outlook'}
                />
              </div>
            </div>
          </Modal>
        </div>
        <UITabBar
          titles={titles}
          activeTab={activeTab}
          onPressTab={handlePressTab}
          containerStyle="mt-4"
          activeTabText="text-text2"
        />
        {activeTab == 'Profile Information' && (
          <ProfileInformation
            scrRecordRefetch={() => {
              scrRecord.refetch()
            }}
            data={scrRecord?.data}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
          />
        )}
        {activeTab == 'Employment' && (
          <Employment
            scrRecordRefetch={() => {
              scrRecord.refetch()
            }}
            data={scrRecord?.data}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
          />
        )}
        {activeTab == 'Safeguarding' && (
          <SafeGuarding
            scrRecordRefetch={() => {
              scrRecord.refetch()
            }}
            data={scrRecord?.data}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
          />
        )}
        {activeTab == 'Training Records' && (
          <TrainingRecords
            scrRecordRefetch={() => {
              scrRecord.refetch()
            }}
            data={scrRecord?.data}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
          />
        )}
        {activeTab == 'Policies' && <Policies data={scrRecord?.data} />}
        {activeTab == 'Notes' && (
          <Notes
            setIsOpenEditNotesModal={setIsOpenEditNotesModal}
            setIsOpenDeleteNotesModal={setIsOpenDeleteNotesModal}
            recordId={recordId}
            schoolData={schoolData}
          />
        )}
      </div>
    </div>
  )
}

export default UserView
